import styled from 'styled-components';

export const StyledProduct = styled.div`
  .product-gallery-images {
    margin: 0 0 10px;

    .head,
    .add-more {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .head {
      margin: 0 0 10px;

      .add-more {
        background: var(--primary);
        color: var(--white);
        padding: 6px 12px;
        border-radius: 60px;
      }
    }
  }

  .product-design-section {
    margin: 0 0 10px;

    .label {
      margin: 0 0 20px;
    }
  }

  .upload-field-holder {
    > div {
      margin: 0 0 10px;
    }

    &.feature {
      margin: 0 0 20px;
    }
  }

  .faqs-holder {
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 20px;

      .add-more {
        margin: 0;
      }
    }

    .faq {
      position: relative;
    }
  }

  .remove-btn,
  .remove-thickness-btn {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--danger);
    background: var(--white);
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

  .feature-images-holder {
    margin: 20px 0;
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 20px;

    .add-more {
      margin: 0;
    }
  }

  .materials-holder,
  .finishes-holder,
  .inserts-holder {
    margin: 0 0 20px;

    .thickness-section {
      margin: 0 0 20px;
    }

    .thickness-item {
      position: relative;
    }

    .card {
      position: relative;
      border: 1px solid var(--border-color);
      padding: 10px;
      border-radius: 10px;
    }
  }

  .label,
  .add-more {
    display: block;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }

  .customization-heading {
    margin: 0 0 20px;
  }

  .add-more {
    display: flex;
    align-items: center;
    gap: 5px;
    background: var(--primary);
    color: var(--white);
    padding: 6px 12px;
    border-radius: 60px;
    margin: 0 0 15px auto;
  }

  textarea {
    min-height: 120px;
    resize: none;
  }

  .personalization-holder {
    .label {
      margin: 0 0 20px;
    }
  }

  /* .feature-detail-holder,
  .materials-holder {
    .label {
      margin: 0 0 10px;
    }
  } */
`;
